import { useCallback, useEffect, useState } from 'react'
import { twinFetchPostJSON } from '../../../../utils/globals/data'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { VirtualTableListingStateLess } from '../../../TwinTable/VirtualTableListing'
import { CustomRenderDate, CustomRenderString, CustomRenderStringAndColorNull } from '../../../TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../TwinTable/VirtualTableListing/Subcomponents/types'
import { TaskModelType } from '@teinor/erp/types/company/task'
import { CustomerProjectModelType, ProjectTypesKeys } from '@teinor/erp/types/company/customer/customerProject'
import TwinIcon from '../../../TwinIcon'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons'
import useEditDeleteModal from '../../../../utils/hooks/useEditDeleteModal'
import ModalEditCustomerProject from '../../../../specificComponents/Customers/ModalEditCustomerProject'

interface DSBAllCustomerProjectsTableProps extends TableAllCustomerProjectsProps {
    title: string
    projectType: ProjectTypesKeys
}

const DSBAllCustomerProjectsTable: React.FC<DSBAllCustomerProjectsTableProps> = ({ title, start_date, end_date, projectType }) => {
    return (
        <div className='flex flex-auto flex-col'>
            <h3 className='pb-15'>{title}</h3>
            <TableAllCustomerProjects start_date={start_date} end_date={end_date} projectType={projectType} />
        </div>
    )
}

interface TableAllCustomerProjectsProps extends TableAllCustomerProjectsLogicProps { }

const TableAllCustomerProjects: React.FC<TableAllCustomerProjectsProps> = ({ start_date, end_date, projectType }) => {
    const { t } = useTwinTranslation()
    const { data, openModal, setOpenModal } = useTableAllCustomerProjectsLogic({ start_date, end_date, projectType })
    const columns: ColumnTableSchema<CustomerProjectModelType> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue} />,
        },
        {
            id: 'CustomerName',
            dataKey: 'Customer',
            label: t('customer', 'Cliente'),
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.Customer?.name || ''} />,
        },
        {
            id: 'CurrentCProjectStatusId',
            dataKey: 'CurrentCProjectStatusId',
            label: t('status', 'Estado'),
            customRender: (_parameterValue, allRowData) => <CustomRenderStringAndColorNull value={allRowData?.CurrentCProjectStatus?.name} color={allRowData?.CurrentCProjectStatus?.color} />,
        },
        {
            id: 'limit_date',
            dataKey: 'limit_date',
            label: t('limitDate', 'Fecha límite'),
            customRender: (parameterValue) => <CustomRenderDate value={parameterValue} />,
        },
        {
            id: 'id',
            dataKey: 'id',
            label: '',
            customRender: (parameterValue) => <TwinIcon icon={faChevronRight} onClick={() => { setOpenModal({ type: 'edit', allRowData: { id: parameterValue } }) }} className='cursor-pointer hover:text-green-43' size='lg' />,
            width: 50
        }
    ]
    return (
        <div className='flex-auto'>
            <VirtualTableListingStateLess tableData={data} rowHeight={48} headerHeight={48} name='DSBAllCustomerProjectsTableDashboard' columns={columns} setSelectedColumnsAndFilters={() => { }} updateEmployeeParameter={false} />
            {openModal?.type === 'edit' ? 
                <ModalEditCustomerProject allRowData={openModal.allRowData} setOpened={()=>setOpenModal(null)} onSubmit={()=>{}} />
                : null
            }
        </div>
    )
}

interface TableAllCustomerProjectsLogicProps {
    start_date: Date
    end_date: Date
    projectType: ProjectTypesKeys
}

const useTableAllCustomerProjectsLogic = ({ start_date, end_date, projectType }: TableAllCustomerProjectsLogicProps) => {
    const [data, setData] = useState<TaskModelType[] | null>(null)
    const { openModal, setOpenModal } = useEditDeleteModal()
    const getData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/customer/customerProject/getAllCustomerProjects', {
            where: {
                projectType,
                limit_date: {
                    '$betweenN': [start_date, end_date]
                }
            }
        })
        if (result) {
            setData(result)
        }
    }, [setData, start_date, end_date, projectType])

    useEffect(() => {
        getData()
    }, [getData])

    return { data, openModal, setOpenModal }
}

export default DSBAllCustomerProjectsTable